import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Card, CardContent, TextField, Typography } from '@mui/material';
import 'quill/dist/quill.snow.css';
import Quill from 'quill';

const EditorCard = styled(Card)({
    maxWidth: 800,
    width:'100%',
    margin: 'auto',
    marginTop: 5,
    borderRadius: `16px 16px 16px 16px`, // Add border radius here
});

const EditorContainer = styled(CardContent)({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: `16px 16px 16px 16px`, // Add border radius here

});


const ContentEditor = ({setEditorContent}) => {
   
  //  const [editorContent1, setEditorContent] = useState('');

   
   // console.log("editorContent1", editorContent1);

    const quillRef = React.useRef(null);

    React.useEffect(() => {
        if (quillRef.current) {
            const quill = new Quill(quillRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['link', 'image', 'video'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                    ],
                },
            });

            quill.on('text-change', () => {
                setEditorContent(quill.root.innerHTML);
            });        }
    }, [quillRef, setEditorContent]);

    return (
            <EditorContainer>
                <Typography variant="h6" gutterBottom>
                    Content
                </Typography>
                <div ref={quillRef} style={{ height: '280px' }} />
                
            </EditorContainer>
    );
};
ContentEditor.propTypes =
{
    setEditorContent: PropTypes.func
}

export default ContentEditor;
